/* L’Expérience Mercier — fil vertical, produits Shopify et ruban vivant.
   Les images illustrent les références configurées. Aucun produit de remplacement.
   Chargé exclusivement par la section maison-mercier-experience. */
(() => {
'use strict';
function mount(root) {
 if (root.dataset.mounted) return;
 root.dataset.mounted = 'true';
 const $ = s => root.querySelector(s);
 const $$ = s => [...root.querySelectorAll(s)];
 const controller = new AbortController();
 const on = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: controller.signal });
 const feed = $('[data-mm-feed]');
 const status = $('[data-mm-status]');
 const shop = $('.mm-xp__shop');
 const list = $('[data-mm-products]');
 const reduce = matchMedia('(prefers-reduced-motion: reduce)');
 let looks;
 try { looks = JSON.parse($('[data-mm-xp-data]').textContent); }
 catch { status.textContent = 'Les looks ne sont pas disponibles pour le moment.'; return; }
 const slides = $$('[data-mm-look]');
 const byKey = new Map(looks.map(l => [l.key, l]));
 const alignSpots = slide => {
   const img = slide.querySelector('img'), spots = slide.querySelector('.mm-xp__hotspots');
   if (!img?.naturalWidth || !spots || !slide.clientWidth || !slide.clientHeight) return;
   const scale = Math.min(slide.clientWidth / img.naturalWidth, slide.clientHeight / img.naturalHeight);
   const w = img.naturalWidth * scale, h = img.naturalHeight * scale;
   Object.assign(spots.style, { inset: 'auto', left: ((slide.clientWidth-w)/2)+'px', top: ((slide.clientHeight-h)/2)+'px', width:w+'px', height:h+'px' });
 };
 slides.forEach(slide => { const img=slide.querySelector('img'); slide.style.setProperty('--look-image','url('+JSON.stringify(img.src)+')'); on(img,'load',()=>alignSpots(slide)); alignSpots(slide); });
 const sceneResize = new ResizeObserver(() => slides.forEach(alignSpots)); sceneResize.observe(feed);
 const cache = new Map();
 const selections = new Map();
 const refreshes = new Map();
 let active = null, filter = 'all', revision = 0, focusBeforeShop = null, timer;
 const route = window.Shopify?.routes?.root || '/';
 const currency = root.dataset.currency || window.Shopify?.currency?.active || 'EUR';
 const money = value => new Intl.NumberFormat(document.documentElement.lang || 'fr-BE', { style: 'currency', currency }).format(value / 100);
 const visibleSlides = () => slides.filter(s => !s.hidden);
 const safeImage = value => { try { const u = new URL(String(value).startsWith('//') ? 'https:' + value : value, location.origin); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; } };
 function setStatus(text) { status.textContent = text; }
 function currentNumber() {
   const visible = visibleSlides(); const i = Math.max(0, visible.indexOf(active));
   $('[data-mm-counter]').textContent = String(i + 1).padStart(2, '0') + ' / ' + String(visible.length).padStart(2, '0');
   $('[data-mm-lookno]').textContent = String(i + 1).padStart(2, '0');
   $('[data-mm-prev]').disabled = i <= 0;
   $('[data-mm-next]').disabled = i >= visible.length - 1;
 }
 function productUrl(p, id) { const url = new URL(p.url, location.origin); if (id) url.searchParams.set('variant', id); return url.pathname + url.search; }
 function element(tag, className, text) { const e = document.createElement(tag); if (className) e.className = className; if (text != null) e.textContent = text; return e; }
 function drawProducts(look) {
   list.replaceChildren();
   look.products.forEach((original, slot) => {
     const live = cache.get(original.handle);
     const p = live?.data || original;
     const card = element('article', 'mm-xp__product');
     card.dataset.slot = slot + 1;
     const imageLink = element('a', 'mm-xp__product-image'); imageLink.href = productUrl(original);
     imageLink.setAttribute('aria-label', original.title);
     const img = element('img'); img.src = safeImage(original.image); img.alt = original.title; img.width = 120; img.height = 150; img.loading = 'lazy';
     imageLink.append(img);
     const body = element('div', 'mm-xp__product-body');
     body.append(element('p', 'mm-xp__product-brand', String(slot + 1).padStart(2, '0') + ' / ' + (p.vendor || original.vendor)));
     const title = element('a', 'mm-xp__product-title', p.title); title.href = productUrl(original);
     body.append(title);
     const price = element('p', 'mm-xp__product-price');
     const select = element('select', 'mm-xp__size'); select.setAttribute('aria-label', 'Taille et couleur — ' + original.title);
     const variants = p.variants || [];
     variants.forEach(v => { const option = element('option', '', v.title + (v.available ? '' : ' — épuisé')); option.value = v.id; option.disabled = !v.available; select.append(option); });
     const first = variants.find(v => v.available); const retained = variants.find(v => String(v.id) === String(selections.get(original.handle)) && v.available); if (retained || first) select.value = (retained || first).id;
     const links = element('div', 'mm-xp__product-links');
     const view = element('a', 'mm-xp__product-view', 'Voir l’article ↗');
     const add = element('button', 'mm-xp__product-add', '+ Panier'); add.type = 'button';
     const update = () => {
       const variant = variants.find(v => String(v.id) === select.value);
       price.textContent = variant ? money(variant.price) : original.priceMoney;
       const verified = Boolean(live && Date.now() - live.time < 60000);
       add.disabled = !verified || !variant?.available;
       select.disabled = !verified || !first;
       view.href = productUrl(original, variant?.id);
       imageLink.href = title.href = view.href;
     };
     select.addEventListener('change', () => { selections.set(original.handle, select.value); update(); });
     add.addEventListener('click', async () => {
       const previous = add.textContent; add.disabled = true; add.textContent = 'Ajout…';
       try {
         const fresh = await fetchProduct(original, true);
         const selected = fresh.variants.find(v => String(v.id) === select.value);
         if (!selected?.available) throw Error('Cette taille vient d’être épuisée. Choisissez-en une autre.');
         const response = await fetch(route + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: selected.id, quantity: 1, sections: 'cart-icon-bubble,cart-sidebar-items,cart-sidebar-footer,cart-sidebar-shipping-bar', sections_url: location.pathname }), signal: controller.signal });
         const data = await response.json();
         if (!response.ok) throw Error(data.description || 'L’ajout n’a pas abouti. Réessayez.');
         closeShop();
         const sidebar = document.querySelector('cart-sidebar');
         if (typeof sidebar?.renderContents === 'function') sidebar.renderContents(data);
         else location.assign(route + 'cart');
         setStatus('Article ajouté au panier.');
       } catch (e) { if (e.name !== 'AbortError') setStatus(e.message); }
       finally { add.textContent = previous; update(); }
     });
     links.append(view, add); body.append(price, select, links); card.append(imageLink, body); list.append(card); update();
   });
 }
 async function fetchProduct(p, force = false) {
   const saved = cache.get(p.handle);
   if (!force && saved && Date.now() - saved.time < 30000) return saved.data;
   if (refreshes.has(p.handle)) return refreshes.get(p.handle);
   const promise = (async () => {
     const res = await fetch(route + 'products/' + encodeURIComponent(p.handle) + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.any([controller.signal, AbortSignal.timeout(12000)]) });
     if (!res.ok) throw Error('La disponibilité ne peut pas être vérifiée. Ouvrez la fiche produit.');
     const data = await res.json();
     if (String(data.id) !== String(p.id) || data.handle !== p.handle) throw Error('La référence du produit a changé.');
     cache.set(p.handle, { time: Date.now(), data }); return data;
   })().finally(() => refreshes.delete(p.handle));
   refreshes.set(p.handle, promise); return promise;
 }
 async function refresh(look, token) {
   try {
     const products = [];
     for (const p of look.products) products.push(await fetchProduct(p));
     if (token !== revision || controller.signal.aborted) return;
     if (products.some(p => !p.available)) {
       const slide = slides.find(s => s.dataset.mmLook === look.key);
       slide.dataset.unavailable = 'true'; slide.hidden = true;
       setStatus('Un article de ce look est épuisé. Voici le look suivant.');
       const next = visibleSlides()[0];
       if (next) { next.scrollIntoView({ block: 'nearest', behavior: 'instant' }); activate(next); }
       else { list.replaceChildren(); setStatus('Aucun look complet disponible actuellement. Retrouvez les pièces dans la boutique.'); }
       return;
     }
     const focused = list.contains(document.activeElement) ? { slot: document.activeElement.closest('[data-slot]')?.dataset.slot, tag: document.activeElement.tagName, value: document.activeElement.value } : null;
     // Do not rebuild a control that the visitor is currently using.
     if (!focused) drawProducts(look);
     setStatus('Prix et disponibilités actualisés.');
   } catch (e) {
     if (e.name === 'AbortError' || token !== revision) return;
     setStatus('Vérification indisponible. Les fiches produit restent accessibles.');
     list.querySelectorAll('button,select').forEach(b => { b.disabled = true; });
   }
 }
 function activate(slide) {
   if (!slide || slide.hidden || slide === active) return;
   active?.classList.remove('is-active'); active = slide; slide.classList.add('is-active'); alignSpots(slide);
   const look = byKey.get(slide.dataset.mmLook); if (!look) return;
   revision++;
   root.dataset.currentLook = look.key;
   $('[data-mm-current]').textContent = look.title;
   drawProducts(look); currentNumber();
   setStatus('Vérification des tailles disponibles…');
   refresh(look, revision);
   const following = visibleSlides()[visibleSlides().indexOf(slide) + 1];
   following?.querySelector('img')?.setAttribute('loading', 'eager');
 }
 function navigate(step) {
   const visible = visibleSlides(), i = visible.indexOf(active);
   const target = visible[Math.max(0, Math.min(visible.length - 1, i + step))];
   target?.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'nearest' });
 }
 function selectFilter(value) {
   filter = value;
   slides.forEach(slide => { slide.hidden = slide.dataset.unavailable === 'true' || (filter !== 'all' && slide.dataset.gender !== filter); });
   $$('[data-mm-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mmFilter === filter)));
   slides.forEach(s => s.classList.remove('is-active')); active = null; feed.scrollTop = 0;
   activate(visibleSlides()[0]);
 }
 function openShop(slot) {
   focusBeforeShop = document.activeElement;
   root.classList.add('is-shop-open');
   const card = list.querySelector('[data-slot="' + (slot || 1) + '"]');
   $$('.mm-xp__product').forEach(p => p.classList.toggle('is-selected', p === card));
   if (matchMedia('(max-width: 760px)').matches) {
     shop.setAttribute('role', 'dialog'); shop.setAttribute('aria-modal', 'true');
     feed.inert = true; $('.mm-xp__top').inert = true;
     requestAnimationFrame(() => (card?.querySelector('select:not(:disabled),a') || shop).focus({ preventScroll: true }));
   } else { card?.querySelector('select:not(:disabled),a')?.focus({ preventScroll: true }); }
 }
 function closeShop() {
   root.classList.remove('is-shop-open'); shop.removeAttribute('role'); shop.removeAttribute('aria-modal');
   feed.inert = false; $('.mm-xp__top').inert = false;
   focusBeforeShop?.focus({ preventScroll: true });
 }
 on(root, 'click', e => {
   const f = e.target.closest('[data-mm-filter]'); if (f) selectFilter(f.dataset.mmFilter);
   const spot = e.target.closest('[data-mm-slot]'); if (spot) { activate(slides.find(s => s.dataset.mmLook === spot.dataset.mmKey)); openShop(Number(spot.dataset.mmSlot)); }
   const shopButton = e.target.closest('[data-mm-shop]'); if (shopButton) openShop(1);
 });
 on($('[data-mm-prev]'), 'click', () => navigate(-1));
 on($('[data-mm-next]'), 'click', () => navigate(1));
 on($('[data-mm-close-shop]'), 'click', closeShop);
 on(document, 'keydown', e => {
   if (root.classList.contains('is-shop-open') && matchMedia('(max-width: 760px)').matches) {
     if (e.key === 'Escape') { e.preventDefault(); closeShop(); }
     if (e.key === 'Tab') {
       const focusable = [...shop.querySelectorAll('a,button:not(:disabled),select:not(:disabled)')].filter(e => e.getClientRects().length);
       const first = focusable[0], last = focusable.at(-1);
       if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
       else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
     }
     return;
   }
   if (!feed.contains(e.target) || /SELECT|INPUT|TEXTAREA|BUTTON|A/.test(e.target.tagName)) return;
   if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); navigate(1); }
   if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); navigate(-1); }
   if (e.key === 'Home') { e.preventDefault(); visibleSlides()[0]?.scrollIntoView({ block: 'nearest', behavior: 'instant' }); }
 });
 let scrollFrame;
 on(feed, 'scroll', () => {
   if (scrollFrame) return;
   scrollFrame = requestAnimationFrame(() => {
     scrollFrame = 0;
     const visible = visibleSlides(); let best = null, distance = Infinity;
     for (const slide of visible) { const d = Math.abs(slide.offsetTop - feed.scrollTop); if (d < distance) { best = slide; distance = d; } }
     activate(best);
   });
 }, { passive: true });
 // Scroll naturally inside the feed; gestures in the side columns advance it too.
 on($('.mm-xp__art'), 'wheel', e => { if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) feed.scrollBy({ top: e.deltaY * (e.deltaMode === 1 ? 20 : 1), behavior: 'instant' }); }, { passive: true });
 const fit = () => {
   const previewInset = document.getElementById('PBarNextFrame') || new URLSearchParams(location.search).has('preview_theme_id') ? 64 : 0;
   const viewport = (window.visualViewport?.height || window.innerHeight) - previewInset;
   const top = root.getBoundingClientRect().top;
   root.style.setProperty('--mm-xp-height', Math.max(570, viewport - Math.max(0, top)) + 'px');
   root.classList.toggle('is-compact', viewport - Math.max(0, top) < 800);
 };
 on(window, 'resize', fit); on(window.visualViewport, 'resize', fit); fit();
 const previewObserver = new MutationObserver(() => { if (document.getElementById('PBarNextFrame')) { fit(); previewObserver.disconnect(); } });
 if (!document.getElementById('PBarNextFrame')) previewObserver.observe(document.body, { childList: true, subtree: true });
 on(document, 'visibilitychange', () => { if (!document.hidden && active) refresh(byKey.get(active.dataset.mmLook), revision); });
 timer = setInterval(() => { if (!document.hidden && active) refresh(byKey.get(active.dataset.mmLook), revision); }, 45000);
 const stopArt = createSilk($('[data-mm-canvas]'), root, reduce, on);
 activate(visibleSlides()[0]);
 on(document, 'shopify:section:unload', e => { if (!e.target.contains(root)) return; clearInterval(timer); cancelAnimationFrame(scrollFrame); stopArt(); previewObserver.disconnect(); sceneResize.disconnect(); controller.abort(); });
}
function createSilk(canvas, root, reduce, on) {
 const ctx = canvas?.getContext('2d', { alpha: true }); if (!ctx) return () => {};
 const host = canvas.parentElement; let w = 0, h = 0, dpr = 1, frame = 0, tx = 0, ty = 0, x = 0, y = 0, visible = true;
 const resize = () => { const r = host.getBoundingClientRect(); w = r.width; h = r.height; dpr = Math.min(devicePixelRatio || 1, 1.6); canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
 const ro = new ResizeObserver(resize); ro.observe(host); resize();
 const io = new IntersectionObserver(entries => { visible = entries.some(e => e.isIntersecting); }); io.observe(host);
 on(root, 'pointermove', e => { if (reduce.matches) return; const r = root.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width * 2 - 1; ty = (e.clientY - r.top) / r.height * 2 - 1; }, { passive: true });
 on(root, 'pointerleave', () => { tx = 0; ty = 0; });
 const render = time => {
   frame = requestAnimationFrame(render);
   if (document.hidden || !visible || !w || !h) return;
   x += (tx - x) * .055; y += (ty - y) * .055;
   const t = reduce.matches ? 0 : time * .00018;
   const mx = reduce.matches ? 0 : x, my = reduce.matches ? 0 : y;
   ctx.clearRect(0, 0, w, h);
   ctx.save(); ctx.translate(w * .5 + mx * 14, h * .5 + my * 10);
   const size = Math.min(w * .43, h * .30);
   const glow = ctx.createRadialGradient(0, 0, 0, 0, 0, size * 1.6); glow.addColorStop(0, 'rgba(194,159,93,.1)'); glow.addColorStop(1, 'rgba(194,159,93,0)');
   ctx.fillStyle = glow; ctx.fillRect(-w, -h, w * 2, h * 2);
   const strands = 94;
   for (let j = 0; j < strands; j++) {
     const v = (j / (strands - 1) - .5) * 1.4;
     ctx.beginPath(); let depth = 0;
     for (let k = 0; k <= 140; k++) {
       const u = k / 140 * Math.PI * 2;
       const r = 1 + v * .24 * Math.cos(u * 1.5 + t);
       let px = Math.cos(u) * r;
       let py = Math.sin(u) * r;
       let pz = Math.sin(u * 2 + t * .7) * .46 + v * .65;
       const a = .55 + mx * .48 + Math.sin(t) * .12, b = -.25 + my * .3;
       const qx = px * Math.cos(a) + pz * Math.sin(a), qz = -px * Math.sin(a) + pz * Math.cos(a);
       const qy = py * Math.cos(b) - qz * Math.sin(b), zz = py * Math.sin(b) + qz * Math.cos(b);
       const perspective = 2.8 / (2.8 - zz);
       const sx = qx * size * perspective, sy = qy * size * 1.32 * perspective;
       if (k === 0) ctx.moveTo(sx, sy); else ctx.lineTo(sx, sy); depth += zz;
     }
     const l = 40 + j / strands * 40;
     ctx.strokeStyle = 'hsla(39,35%,' + l + '%,' + (.18 + Math.sin(j / strands * Math.PI) * .47) + ')';
     ctx.lineWidth = j % 9 === 0 ? 1 : .52; ctx.stroke();
   }
   ctx.restore();
   root.dataset.artX = x.toFixed(2);
 };
 frame = requestAnimationFrame(render);
 return () => { cancelAnimationFrame(frame); ro.disconnect(); io.disconnect(); };
}
function start(scope = document) { scope.querySelectorAll('[data-mm-experience]').forEach(mount); }
start(); document.addEventListener('shopify:section:load', e => start(e.target));
})();
